import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { AbstractControl, FormControl } from '@angular/forms'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { distinctUntilChanged } from 'rxjs'

import { Validators } from '@angular/forms'
import { PasswordComplexityPolicy } from 'libs/shared/models/shared.models'

@UntilDestroy()
@Component({
  selector: 'gb-password-field',
  templateUrl: './gb-password-field.component.html',
  styleUrls: ['./gb-password-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbPasswordFieldComponent implements OnInit {
  @Input() label = 'PASSWORD_INPUT_LABEL'
  @Input() validateComplexity = true
  @Input() autocomplete = 'password'
  @Input() set control(control: FormControl | AbstractControl) {
    this._control = control as FormControl
  }

  get control(): FormControl {
    return this._control
  }

  private _control!: FormControl
  showPassword = false
  showPasswordHint = false
  passwordComplexityPolicy$ = this.auctionFacade.passwordComplexityPolicy$

  constructor(private auctionFacade: AuctionFacade) {}

  ngOnInit(): void {
    if (this.validateComplexity) this.initValidators()
  }

  initValidators(): void {
    this.auctionFacade.passwordComplexityPolicy$
      .pipe(untilDestroyed(this), distinctUntilChanged())
      .subscribe((passwordComplexityPolicy) => {
        if (passwordComplexityPolicy) {
          this.setPasswordComplexityPolicy(passwordComplexityPolicy)
        } else {
          this.control.addValidators(Validators.minLength(6))
        }
      })
  }

  setPasswordComplexityPolicy(pwdPolicy: PasswordComplexityPolicy): void {
    for (const key in pwdPolicy) {
      const field = pwdPolicy[key as keyof PasswordComplexityPolicy]
      if (field.unit > 0) {
        this.control.addValidators(Validators.pattern(new RegExp(field.regex)))
      }
    }
  }

  onFocus(): void {
    if (this.validateComplexity) this.showPasswordHint = true
  }

  toggleShowPassword(): void {
    this.showPassword = !this.showPassword
  }

  getPasswordFieldType(): string {
    return this.showPassword ? 'text' : 'password'
  }
}
